"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const theme_1 = require("../../theme/theme");
const SvgBox = props => {
  const stroke = props.stroke || theme_1.mainTheme.colors.primary_700_main;
  const width = props.width || 21;
  const height = props.height || 24;
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: width,
    fill: "none",
    height: height,
    viewBox: "0 0 21 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M2.70264 4.93213H18.2361V21.2999C18.2361 21.9902 17.6765 22.5499 16.9861 22.5499H3.95264C3.26228 22.5499 2.70264 21.9902 2.70264 21.2999V4.93213Z",
      stroke: stroke,
      strokeWidth: "1.5"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M6.65088 5.05396H14.2884V2.64776C14.2884 1.95741 13.7288 1.39776 13.0384 1.39776H7.90088C7.21052 1.39776 6.65088 1.95741 6.65088 2.64776V5.05396Z",
      stroke: stroke,
      strokeWidth: "1.5"
    }), (0, jsx_runtime_1.jsx)("rect", {
      x: "0.811766",
      y: "4.58765",
      width: "19.3151",
      height: "0.811032",
      rx: "0.405516",
      stroke: stroke,
      strokeWidth: "0.811032"
    }), (0, jsx_runtime_1.jsx)("line", {
      x1: "6.99023",
      y1: "9.70605",
      x2: "6.99023",
      y2: "17.7759",
      stroke: stroke,
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }), (0, jsx_runtime_1.jsx)("line", {
      x1: "10.4692",
      y1: "9.70605",
      x2: "10.4692",
      y2: "17.7759",
      stroke: stroke,
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }), (0, jsx_runtime_1.jsx)("line", {
      x1: "13.9482",
      y1: "9.70605",
      x2: "13.9482",
      y2: "17.7759",
      stroke: stroke,
      strokeWidth: "1.5",
      strokeLinecap: "round"
    })]
  });
};
exports.default = SvgBox;